import { apiClient } from "@/shared/api/client"

/** Describes a single file to request a presigned upload URL for. */
export interface PresignRequestFile {
	filename: string
	mimeType: string
	size: number
	type: string
	order?: number
	width?: number
	height?: number
	duration?: number
}

/** Response returned by {@link presignUpload}, containing one presigned URL per requested file. */
export interface PresignResponse {
	uploads: Array<{
		url: string
		s3Key: string
		filename: string
		mimeType: string
		size: number
		type: string
		order?: number
		width?: number
		height?: number
		duration?: number
	}>
}

/** Payload for finalizing previously-uploaded media via {@link completeMediaUpload}. */
export interface CompleteMediaRequest {
	media: Array<{
		s3Key: string
		type: string
		filename?: string
		mimeType?: string
		size?: number
		order?: number
		width?: number
		height?: number
		duration?: number
	}>
}

/** Requests presigned S3 upload URLs for a set of media files belonging to a post. */
export const presignUpload = async (
	postId: string,
	files: PresignRequestFile[],
): Promise<PresignResponse> => {
	const response = await apiClient.post<PresignResponse>(`/admin/posts/${postId}/media/presign`, {
		files,
	})
	return response.data
}

/** Notifies the backend that media files have finished uploading to S3, registering them on the post. */
export const completeMediaUpload = async (
	postId: string,
	media: CompleteMediaRequest["media"],
	skipPreview = false,
): Promise<{ success: boolean }> => {
	const response = await apiClient.post<{ success: boolean }>(
		`/admin/posts/${postId}/media/complete`,
		{ media, skipPreview },
	)
	return response.data
}
